module.exports = __webpack_public_path__ + "static/media/2.266ccfb8.jpeg";